import {
  Controller,
  type Control,
  type FieldErrors,
  type FieldValues,
  type Path,
} from 'react-hook-form';
import { DatePickerInput } from '@/components/common/DatePickerInput';
import { Label } from '@/components/ui/label';
import { getUserFieldLabel, type DateUserField } from '../../constants/user.constants';

interface DateFieldProps<T extends FieldValues> {
  name: DateUserField;
  control: Control<T>;
  errors: FieldErrors<T>;
}

export function DateField<T extends FieldValues>({ name, control, errors }: DateFieldProps<T>) {
  const label = getUserFieldLabel(name);
  const error = errors[name as Path<T>];

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={name}>{label}</Label>
      <Controller
        name={name as Path<T>}
        control={control}
        render={({ field }) => (
          <DatePickerInput
            id={name}
            value={typeof field.value === 'string' ? field.value : ''}
            onChange={(value) => field.onChange(value === '' ? undefined : value)}
            aria-invalid={error !== undefined}
          />
        )}
      />
      {typeof error?.message === 'string' && (
        <p className="text-xs text-destructive">{error.message}</p>
      )}
    </div>
  );
}
